export function initCookiePopup() {
  const popup = document.querySelector('.cookie-popup');
  if (!popup) return;

  // Check for previous consent
  const consent = localStorage.getItem('cookieConsent');
  if (consent === 'accepted' || consent === 'declined') return; // Already set

  // Reveal the popup
  popup.classList.add('cookie-popup--visible');

  // Button selectors
  const acceptBtn = popup.querySelector('.cookie-popup__button--accept');
  // const declineBtn = popup.querySelector('.cookie-popup__button--decline');
  // const closeBtn = popup.querySelector('.cookie-popup__close');

  const closePopup = (choice) => {
    if (choice) localStorage.setItem('cookieConsent', choice);
    popup.classList.remove('cookie-popup--visible');
    // Optionally: add transitionend listener to fully hide/remove from DOM after fade out
  };

  acceptBtn?.addEventListener('click', () => closePopup('accepted'));
  // declineBtn?.addEventListener('click', () => closePopup('declined'));
  // closeBtn?.addEventListener('click', () => closePopup()); // No storage, just closes
}
